import { __assign, __rest } from "tslib";
import * as React from 'react';
import YouzanIcon from './Youzan';
import CircleIcon from './Circle';
export default function Icon(_a) {
    var icon = _a.icon, rest = __rest(_a, ["icon"]);
    if (icon === 'youzan') {
        return React.createElement(YouzanIcon, __assign({}, rest));
    }
    if (icon === 'circle') {
        return React.createElement(CircleIcon, __assign({}, rest));
    }
    return null;
}
